/*
  Patchstitch 定制选项 · 品牌皮肤（Fil & Nous）—— 配合 fn-ps-skin.css
  - 给每个选项判断类型（线色 / 衣服颜色 / 图标 / 文字单选），写到 data-fn-kind
  - 线色：从 App 色块原图里取颜色，画成彩色线轴；取色失败时用「线色对照表」（主题编辑器 · 购买区设置），都没有则保留 App 原图
  - 标题后显示已选值；同价加价项把「+2 €」提到标题里
  - 文字输入框下方显示推荐输入（主题编辑器 · 文字定制项 · 推荐输入）
  - App 会重新渲染面板：用 MutationObserver 反复套用，所有步骤都可重复执行
*/
(function () {
  if (window.__fnPsSkin) return; window.__fnPsSkin = true;

  var SPOOL = '<svg class="fn-ps-spool" viewBox="0 0 46 56" aria-hidden="true" focusable="false">' +
    '<path class="bow" d="M23 11V8M23 8c-2.2-3.3-6.6-3.5-6.3-.8.3 2.3 4.2 2 6.3.8zM23 8c2.2-3.3 6.6-3.5 6.3-.8-.3 2.3-4.2 2-6.3.8z"/>' +
    '<rect class="fl" x="11" y="11" width="24" height="5" rx="2.4"/>' +
    '<rect class="core" x="14" y="16" width="18" height="30"/>' +
    '<path class="tex" d="M14 21l18-4M14 25.5l18-4M14 30l18-4M14 34.5l18-4M14 39l18-4M14 43.5l18-4"/>' +
    '<rect class="fl" x="11" y="46" width="24" height="5" rx="2.4"/></svg>';

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); }
  function parseMap(txt) {
    var m = {};
    (txt || '').split(/\n|;/).forEach(function (line) {
      var i = line.lastIndexOf('='); if (i < 0) i = line.lastIndexOf(':');
      if (i < 0) return;
      var k = norm(line.slice(0, i)), v = line.slice(i + 1).trim();
      if (k && /^#?[0-9a-f]{3,8}$/i.test(v)) m[k] = v.charAt(0) === '#' ? v : '#' + v;
    });
    return m;
  }
  function isLight(hex) {
    var h = hex.replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 200;
  }
  /* 名字匹配：先整串，再拆成单词逐个试（如「JOY03-Argent」→ argent） */
  function lookup(map, name) {
    var k = norm(name); if (map[k]) return map[k];
    var parts = k.split(/[-_\/|·,()]+/).map(function (x) { return x.trim(); }).filter(Boolean);
    for (var i = parts.length - 1; i >= 0; i--) if (map[parts[i]]) return map[parts[i]];
    return '';
  }
  function paint(c, sv, hex) {
    sv.style.setProperty('--c', hex); sv.classList.toggle('is-light', isLight(hex));
    c.classList.add('fn-ps-has-spool');
  }
  function unspool(c, sv) { sv.remove(); c.classList.remove('fn-ps-has-spool'); }

  /* 从 App 色块图里取颜色：图是圆形色块、中间印着颜色名。只取圆内、避开中间文字横条的像素，取各通道中位数 */
  var cache = {};
  function sample(src, cb) {
    if (!src) return cb('');
    var key = src.split('?')[0];
    if (cache[key] !== undefined) { if (cache[key] && cache[key].then) cache[key].then(cb); else cb(cache[key]); return; }
    var waiters = [cb];
    cache[key] = { then: function (f) { waiters.push(f); } };
    function done(v) { cache[key] = v; waiters.forEach(function (f) { f(v); }); }
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var N = 40, cv = document.createElement('canvas'); cv.width = cv.height = N;
        var x = cv.getContext('2d'); x.drawImage(im, 0, 0, N, N);
        var d = x.getImageData(0, 0, N, N).data, R = [], G = [], B = [];
        for (var py = 0; py < N; py++) for (var px = 0; px < N; px++) {
          var dx = (px + .5) / N - .5, dy = (py + .5) / N - .5, r = Math.sqrt(dx * dx + dy * dy);
          if (r > .4 || Math.abs(dy) < .17) continue;
          var o = (py * N + px) * 4; if (d[o + 3] < 200) continue;
          R.push(d[o]); G.push(d[o + 1]); B.push(d[o + 2]);
        }
        if (!R.length) return done('');
        function med(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
        done('#' + [med(R), med(G), med(B)].map(function (n) { return ('0' + n.toString(16)).slice(-2); }).join(''));
      } catch (e) { done(''); }
    };
    im.onerror = function () { done(''); };
    im.src = key + '?width=80';
  }

  var PRICE = /\s*\(\+\s*([\d.,]+)[\s ]*€\)\s*$/;
  function clean(s) { return (s || '').replace(PRICE, '').trim(); }

  function kindOf(opt) {
    var title = norm((opt.querySelector('.ps-option__title') || {}).textContent);
    /* 衣服色块的图已被挪进 .fn-ps-dot，重复执行时也要算作带图选项，否则会被误判成文字选项、圆点样式失效 */
    var hasImgs = opt.querySelector('.ps-choice > img, .ps-choice > .fn-ps-dot > img');
    /* 文字选项：旧版是 radio 单选，App 新版是 .ps-choice > span 小方块，两种都按「文字按钮」处理（我们自己加的 span 不算） */
    /* 只有色值、没有图的颜色选项（.ps-swatch 小圆点 + 文字）：也按衣服色块处理 */
    if (!hasImgs && opt.querySelector('.ps-choice > .ps-swatch') && /couleur|color|coloris/.test(title)) return 'swatch';
    if (!hasImgs) return opt.querySelector('input[type=radio]') ? 'radio' : (opt.querySelector('.ps-choices > .ps-choice > span:not(.fn-ps-dot):not(.fn-ps-none)') ? 'text' : '');
    if (/\bfil\b|thread/.test(title)) return 'thread';
    /* 花型 / 面料（如「Couleur et motif」）：显示方形花布图，不能当衣服颜色取成纯色圆点 */
    if (/motif|imprime|pattern|tissu/.test(title)) return 'pattern';
    if (/couleur|color|coloris/.test(title)) return 'swatch';
    return 'icon';
  }

  function valueEl(opt) {
    var t = opt.querySelector('.ps-option__title'); if (!t) return null;
    var v = t.querySelector('.fn-ps-val');
    if (!v) { v = document.createElement('span'); v.className = 'fn-ps-val'; t.appendChild(v); }
    return v;
  }

  /* 商品图清单（section 里的 JSON）+「衣服颜色图对照」：颜色名 → 商品图地址 */
  var media = [], swMap = {};
  function mediaFor(name) {
    var k = norm(name); if (!k) return '';
    for (var i = 0; i < media.length; i++) if (norm(media[i].alt) === k) return media[i].src;
    var frag = swMap[k]; if (!frag) return '';
    for (var j = 0; j < media.length; j++) if (media[j].src.split('?')[0].indexOf(frag) > -1) return media[j].src;
    return '';
  }

  var TOUCH = window.matchMedia('(hover:none), (pointer:coarse)');

  /* App 自带的英文文案（必填提示、裁剪弹窗）→ 法语 */
  var FR = {
    'This field is required.': 'Ce champ est obligatoire.',
    'Drag the photo to reposition it, use the buttons to zoom': 'Faites glisser la photo pour la recadrer, + et − pour zoomer',
    'Cancel': 'Annuler',
    'Use photo': 'Valider la photo',
    'Original': 'Originale',
    'Zoom in': 'Zoomer',
    'Zoom out': 'Dézoomer'
  };
  function translate(el) {
    var t = el.textContent.trim(); if (FR[t] && el.textContent !== FR[t]) el.textContent = FR[t];
    var a = el.getAttribute('aria-label'); if (a && FR[a]) el.setAttribute('aria-label', FR[a]);
  }
  function translateCrop() {
    document.querySelectorAll('.ps-crop-dialog .ps-crop-hint, .ps-crop-dialog button').forEach(translate);
  }

  function apply(root, map, ideas) {
    root.classList.add('fn-ps-skin');
    root.querySelectorAll('.ps-option__error-msg').forEach(translate);
    root.querySelectorAll('.ps-option').forEach(function (opt) {
      /* 子选项（如选了「Surnom personnalisé」后出现的输入框）：key 形如「父:序号>子」，归属上一步，不单独编号 */
      if ((opt.getAttribute('data-ps-option-key') || '').indexOf('>') > -1) opt.setAttribute('data-fn-sub', '');
      /* 上传图片：改成一行小按钮，文案换成法语 */
      var up = opt.querySelector('.ps-upload__dropzone');
      if (up) {
        opt.setAttribute('data-fn-kind', 'upload');
        var cb = up.querySelector('.ps-upload__choose-btn'), uh = up.querySelector('.ps-upload__hint');
        var busy = up.classList.contains('is-busy');
        up.setAttribute('aria-busy', String(busy));
        if (cb && cb.textContent !== 'Choisir une photo') cb.textContent = 'Choisir une photo';
        if (uh) {
          uh.setAttribute('role', 'status');
          uh.setAttribute('aria-live', 'polite');
          /* 触屏没法拖拽：不显示「glissez-la ici」（CSS 隐藏空提示）；上传中 App 写的英文状态换成法语 */
          var dropHint = TOUCH.matches ? '' : 'ou glissez-la ici';
          if (!busy && uh.textContent !== dropHint) uh.textContent = dropHint;
          if (busy && /upload/i.test(uh.textContent)) uh.textContent = 'Envoi de la photo…';
        }
        opt.querySelectorAll('.ps-upload button, .ps-upload input').forEach(function (control) {
          if (busy) {
            if (control.__fnUploadDisabled === undefined) control.__fnUploadDisabled = control.disabled;
            control.disabled = true;
          } else if (control.__fnUploadDisabled !== undefined) {
            control.disabled = control.__fnUploadDisabled;
            delete control.__fnUploadDisabled;
          }
        });
        return;
      }
      /* 文字输入框：下方加一排推荐按钮，点一下填入（点击处理见 boot）；当前值等于某个推荐时高亮它 */
      var ti = opt.querySelector(':scope > .ps-text-input-wrap > .ps-text-input');
      var t0 = opt.querySelector('.ps-option__title');
      var list = ti && t0 && t0.firstChild && ideas[norm(t0.firstChild.textContent)];
      if (list) {
        var box = opt.querySelector(':scope > .fn-ps-ideas');
        if (!box) {
          box = document.createElement('div'); box.className = 'fn-ps-ideas';
          box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'Idées');
          var lb = document.createElement('span'); lb.className = 'fn-ps-ideas__label'; lb.textContent = 'Idées :'; box.appendChild(lb);
          list.forEach(function (s) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'fn-ps-idea';
            b.textContent = s; b.setAttribute('data-fn-idea', s); box.appendChild(b);
          });
          ti.parentElement.insertAdjacentElement('afterend', box);
        }
        var cur = norm(ti.value);
        box.querySelectorAll('.fn-ps-idea').forEach(function (b) {
          var s = b.getAttribute('data-fn-idea'), on = String(!/…$/.test(s) && norm(s) === cur);
          if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
        });
      }

      var kind = kindOf(opt); if (!kind) return;
      opt.setAttribute('data-fn-kind', kind);
      var choices = opt.querySelectorAll('.ps-choices > .ps-choice');

      if (kind === 'thread') {
        choices.forEach(function (c) {
          if (c.querySelector('.fn-ps-spool')) return;
          var img = c.querySelector(':scope > img'); var name = clean(img ? img.alt : '');
          /* 先用对照表的颜色立刻画出线轴（避免闪烁），再用 App 色块原图里取到的颜色覆盖；两样都拿不到就显示原图 */
          var hex = lookup(map, name);
          c.insertAdjacentHTML('afterbegin', SPOOL);
          var sv = c.querySelector('.fn-ps-spool');
          c.setAttribute('title', name); c.setAttribute('aria-label', name);
          if (hex) paint(c, sv, hex);
          if (!img) { if (!hex) unspool(c, sv); return; }
          sample(img.currentSrc || img.src, function (got) {
            if (got) paint(c, sv, got); else if (!hex) unspool(c, sv);
          });
        });
      }

      if (kind === 'swatch') {
        /* 色块和悬停预览：有对应的商品图（如换了新领标的图）就用商品图替换 App 原图 */
        choices.forEach(function (c) {
          var im0 = c.querySelector(':scope > img, :scope > .fn-ps-dot > img'); if (!im0) return;
          var url = mediaFor(clean(im0.alt)); if (!url) return;
          c.querySelectorAll('img').forEach(function (im) {
            if (im.getAttribute('data-fn-src') === url) return;
            im.removeAttribute('srcset'); im.src = url; im.setAttribute('data-fn-src', url);
          });
        });
        var tt = norm((opt.querySelector('.ps-option__title') || {}).textContent);
        var cut = /capuche|hood/.test(tt) ? (/sans capuche|crew/.test(tt) ? 'crew' : 'hood') : (/sweat/.test(tt) ? 'crew' : 'tee');
        if (opt.getAttribute('data-fn-cut') !== cut) opt.setAttribute('data-fn-cut', cut);
        choices.forEach(function (c) {
          var hx = c.querySelector(':scope > .ps-swatch');
          if (hx) { var nm = clean(c.textContent); if (c.getAttribute('title') !== nm) { c.setAttribute('title', nm); c.setAttribute('aria-label', nm); } return; }
          if (c.querySelector('.fn-ps-dot')) return;
          var img = c.querySelector(':scope > img'); if (!img) return;
          var dot = document.createElement('span'); dot.className = 'fn-ps-dot';
          c.insertBefore(dot, img); dot.appendChild(img);
          c.setAttribute('title', clean(img.alt)); c.setAttribute('aria-label', clean(img.alt));
        });
        /* 色块一律显示纯色（assets/fn-garment-colors.js）：表里有的用固定色值，没有的从衣服图取色；悬停弹窗里的衣服图不受影响。取色失败才继续显示裁图 */
        choices.forEach(function (c) {
          var dot = c.querySelector(':scope > .fn-ps-dot'); if (!dot || !window.fnGarmentHex) return;
          var img = dot.querySelector('img'), src = img ? img.getAttribute('src') : '';
          var key = c.getAttribute('title') + '|' + src;
          if (dot.getAttribute('data-fn-hex-key') === key) return;
          dot.setAttribute('data-fn-hex-key', key);
          var apply = function (hex) {
            if (dot.getAttribute('data-fn-hex-key') !== key) return;
            dot.style.background = hex; dot.classList.toggle('fn-ps-dot--solid', !!hex);
          };
          var hex = window.fnGarmentHex(c.getAttribute('title'));
          if (hex) apply(hex); else window.fnGarmentSample(src, apply);
        });
      }

      if (kind === 'pattern') {
        choices.forEach(function (c) {
          var img = c.querySelector(':scope > img'); var nm = clean(img ? img.alt : '');
          if (nm && c.getAttribute('title') !== nm) { c.setAttribute('title', nm); c.setAttribute('aria-label', nm); }
        });
      }

      if (kind === 'icon') {
        /* 所有加价项同价时，把价格提到标题里，格子上不再重复 */
        var prices = {}, n = 0;
        choices.forEach(function (c) {
          var img = c.querySelector(':scope > img'); var alt = img ? img.alt : '';
          var m = alt.match(PRICE); if (m) { prices[m[1]] = 1; n++; }
          if (/^non\b|^no\b|^aucun/i.test(clean(alt)) && !c.hasAttribute('data-fn-none')) {
            c.setAttribute('data-fn-none', '');
            var s = document.createElement('span'); s.className = 'fn-ps-none'; s.textContent = 'Non merci'; c.appendChild(s);
          }
          c.setAttribute('title', clean(alt));
        });
        var keys = Object.keys(prices), t = opt.querySelector('.ps-option__title');
        if (t && n && keys.length === 1 && !t.querySelector('.fn-ps-price')) {
          var p = document.createElement('span'); p.className = 'fn-ps-price'; p.textContent = '+' + keys[0].replace(/,00$/, '') + ' €';
          t.insertBefore(p, t.querySelector('.ps-option__required-mark'));
          opt.querySelectorAll('.ps-choice__popup-label').forEach(function (l) { l.textContent = clean(l.textContent); });
        }
        /* 选「Non merci」（不加价）时隐藏标题里的「+2 €」，免得看起来像还在加价 */
        var chip = t && t.querySelector('.fn-ps-price');
        if (chip) {
          var picked = opt.querySelector('.ps-choice[data-selected="true"]');
          var off = !!picked && picked.hasAttribute('data-fn-none');
          if (chip.hidden !== off) chip.hidden = off;
        }
      }

      /* 尺码（App 里的文字单选）：标题旁加「Guide des tailles」（打开购买区已有的尺码弹窗）和一句选码建议 */
      if ((kind === 'radio' || kind === 'text') && /^taille|^size|^pointure/.test(norm((opt.querySelector('.ps-option__title') || {}).firstChild && opt.querySelector('.ps-option__title').firstChild.textContent))) {
        var host = root.closest('[data-fn-thread-colors]'), guide = document.querySelector('[data-fn-guide]');
        if (!opt.hasAttribute('data-fn-size')) opt.setAttribute('data-fn-size', '');
        var tt2 = opt.querySelector('.ps-option__title');
        var ownGuide = opt.querySelector('.ps-size-guide-link');
        /* 通用弹窗只有 XS–4XL 成人码：选项值不是字母码（如 Enfants / Adultes、0-6m）就不加，避免同一商品出现两个按钮或配错表 */
        var letterSizes = Array.prototype.some.call(opt.querySelectorAll('.ps-choice, label'), function (c) {
          return /^(X{0,3}S|M|X{0,4}L|[2-5]XL)\b/i.test(clean(c.textContent));
        });
        /* Prefer the option-specific chart, including charts loaded after the first render. */
        if (ownGuide || !letterSizes) tt2.querySelectorAll('.fn-ps-guide').forEach(function (button) { button.remove(); });
        if (guide && !ownGuide && letterSizes && !tt2.querySelector('.fn-ps-guide')) {
          var gb = document.createElement('button'); gb.type = 'button'; gb.className = 'fn-ps-guide'; gb.textContent = 'Guide des tailles';
          gb.addEventListener('click', function (e) { e.preventDefault(); guide.showModal(); });
          tt2.appendChild(gb);
        }
        /* 选码建议放在标题同一行（已选值之后），不再单独占一行 */
        var hint = host ? host.getAttribute('data-fn-size-hint') : '';
        var commonGuide = tt2.querySelector('.fn-ps-guide');
        if (!commonGuide || !hint) tt2.querySelectorAll('.fn-ps-hint').forEach(function (text) { text.remove(); });
        if (hint && commonGuide && !tt2.querySelector('.fn-ps-hint')) {
          valueEl(opt);
          var hp = document.createElement('span'); hp.className = 'fn-ps-hint'; hp.textContent = hint; tt2.appendChild(hp);
        }
      }

      /* 版型（Modèle / Style 文字选项，最多 4 项）：做成带价格的卡片，价格 = 商品基础价 + 该项加价 */
      if (kind === 'text' && choices.length <= 4 && /^(modele|style)\b/.test(norm((opt.querySelector('.ps-option__title') || {}).firstChild && opt.querySelector('.ps-option__title').firstChild.textContent))) {
        if (!opt.hasAttribute('data-fn-cards')) opt.setAttribute('data-fn-cards', '');
        var base = +((root.closest('[data-fn-base-price]') || {}).getAttribute ? root.closest('[data-fn-base-price]').getAttribute('data-fn-base-price') : 0) || 0;
        choices.forEach(function (c) {
          if (c.querySelector('.fn-ps-card')) return;
          var raw = c.textContent, m = raw.match(PRICE), name = clean(raw);
          var add = m ? Math.round(parseFloat(m[1].replace(/\./g, '').replace(',', '.')) * 100) : 0;
          c.setAttribute('data-fn-name', name);
          var card = document.createElement('span'); card.className = 'fn-ps-card';
          var b = document.createElement('b'); b.textContent = name; card.appendChild(b);
          if (base) { var pr = document.createElement('small'); pr.textContent = '€' + ((base + add) / 100).toFixed(2).replace('.', ','); card.appendChild(pr); }
          c.appendChild(card);
        });
      }

      /* 已选值 */
      var v = valueEl(opt); if (!v) return;
      var txt = '';
      if (kind === 'radio') {
        var ch = opt.querySelector('input[type=radio]:checked');
        if (ch) txt = clean((ch.closest('label') || {}).textContent || '');
      } else {
        var sel = opt.querySelector('.ps-choice[data-selected="true"]');
        if (sel) { var im = sel.querySelector('img'); txt = sel.hasAttribute('data-fn-none') ? 'Non merci' : (sel.getAttribute('data-fn-name') || clean(im ? im.alt : sel.textContent)); }
      }
      txt = txt.trim();
      if (v.textContent !== txt) v.textContent = txt;
    });
  }

  function boot(root) {
    if (root.__fnPs) return; root.__fnPs = true;
    var host = root.closest('[data-fn-thread-colors]');
    var map = parseMap(host ? host.getAttribute('data-fn-thread-colors') : '');
    var mj = host && host.querySelector('[data-fn-media]');
    if (mj) { try { media = JSON.parse(mj.textContent) || []; } catch (e) { media = []; } }
    swMap = {};
    (host ? host.getAttribute('data-fn-swatch-images') || '' : '').split(/\n/).forEach(function (line) {
      var i = line.indexOf('='); if (i < 0) return;
      var k = norm(line.slice(0, i)), v = line.slice(i + 1).trim(); if (k && v) swMap[k] = v;
    });
    /* 推荐输入：每行「选项标题 = 推荐1 | 推荐2」 */
    var ideas = {};
    (host ? host.getAttribute('data-fn-text-ideas') || '' : '').split(/\n/).forEach(function (line) {
      var i = line.indexOf('='); if (i < 0) return;
      var k = norm(line.slice(0, i)), v = line.slice(i + 1).split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      if (k && v.length) ideas[k] = v;
    });
    /* 同步套用：MutationObserver 回调在浏览器绘制前执行，App 重绘面板后不会先露出原样再变（避免「闪白」） */
    var mo = new MutationObserver(run), opts = { childList: true, subtree: true, attributes: true, attributeFilter: ['data-selected', 'class'] };
    /* 真实点击时 App 重建面板后会先让浏览器按「没套皮肤」算一次样式（白底），再套皮肤就会触发 .2s 过渡，所有按钮从白渐变回来。
       有新节点时先关掉过渡、套完皮肤强制算一次样式，再恢复过渡 */
    function run(recs) {
      var fresh = !recs || recs.some(function (r) { return r.addedNodes && r.addedNodes.length; });
      mo.disconnect();
      if (fresh) root.classList.add('fn-ps-instant');
      try { apply(root, map, ideas); } finally {
        if (fresh) { void root.offsetWidth; root.classList.remove('fn-ps-instant'); }
        mo.takeRecords(); mo.observe(root, opts);
      }
      restore();
    }

    /* 输入框打字时页面会跳：App 每敲一个字都把面板清空重建，再对新输入框调用不带 preventScroll 的 focus()，
       浏览器按「还没套皮肤」的高度把输入框滚进视口。按键前记下各层滚动位置，重建期间 focus 不滚动，套完皮肤再放回原位 */
    var saved = null, typing = false;
    function restore() {
      if (!saved) return;
      /* .page-wrapper 带 scroll-behavior: smooth，直接赋值 scrollTop 会变成动画，必须 instant */
      saved.forEach(function (s) { if (s[0].scrollTop !== s[1]) s[0].scrollTo({ top: s[1], behavior: 'instant' }); });
    }
    root.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('.ps-text-input, textarea')) return;
      saved = [];
      for (var el = root.parentElement; el; el = el.parentElement) if (el.scrollHeight > el.clientHeight) saved.push([el, el.scrollTop]);
      typing = true;
      setTimeout(function () { typing = false; restore(); saved = null; });
    }, true);
    var focus0 = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (o) {
      return focus0.call(this, typing && root.contains(this) ? Object.assign({}, o, { preventScroll: true }) : o);
    };

    function uploading() { return !!root.querySelector('.ps-upload__dropzone.is-busy'); }
    function guardUpload(event) {
      if (!uploading()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    root.addEventListener('click', guardUpload, true);
    root.addEventListener('drop', guardUpload, true);
    var form = root.closest('form');
    if (form) form.addEventListener('submit', guardUpload, true);

    /* 点推荐：写进输入框并触发 input，让 App 记下这个值；以「…」结尾的只填开头，光标留在末尾让顾客接着写 */
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.fn-ps-idea'); if (!b || !root.contains(b)) return;
      var opt = b.closest('.ps-option'), ti = opt && opt.querySelector('.ps-text-input'); if (!ti) return;
      var s = b.getAttribute('data-fn-idea'), prefix = /…$/.test(s);
      var v = prefix ? s.replace(/\s*…$/, ' ') : s;
      if (ti.maxLength > 0) v = v.slice(0, ti.maxLength);
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(ti, v);
      ti.dispatchEvent(new Event('input', { bubbles: true }));
      if (!prefix) return;
      /* App 每次输入都会重建输入框，按 key 找到新的再聚焦 */
      var key = opt.getAttribute('data-ps-option-key');
      var fresh = (key && root.querySelector('.ps-option[data-ps-option-key="' + CSS.escape(key) + '"] .ps-text-input')) || ti;
      fresh.focus({ preventScroll: true }); fresh.setSelectionRange(fresh.value.length, fresh.value.length);
    });

    run();
    root.addEventListener('change', function () { run(); });

    /* 弹窗别超出屏幕：显示前按位置算一个水平偏移 */
    function place(c) {
      var pop = c.querySelector('.ps-choice__popup'); if (!pop) return;
      var r = c.getBoundingClientRect(), w = 140, cx = r.left + r.width / 2, m = 12, vw = document.documentElement.clientWidth;
      var dx = Math.min(0, vw - m - (cx + w / 2)) + Math.max(0, m - (cx - w / 2));
      c.style.setProperty('--fn-pop-dx', dx + 'px');
    }
    root.addEventListener('mouseover', function (e) { var c = e.target.closest && e.target.closest('.ps-choice'); if (c && root.contains(c)) place(c); });
    /* Mobile: selecting an option also previews its image for three seconds. */
    var previewTimer = null, previewChoice = null;
    function hidePreview() {
      clearTimeout(previewTimer);
      if (previewChoice) previewChoice.classList.remove('fn-ps-peek');
      previewChoice = null;
    }
    root.addEventListener('click', function (e) {
      if (!window.matchMedia('(max-width:899px), (hover:none), (pointer:coarse)').matches) return;
      var c = e.target.closest && e.target.closest('.ps-choice');
      hidePreview();
      if (!c || !root.contains(c) || !c.querySelector('.ps-choice__popup img')) return;
      var option = c.closest('.ps-option'), key = option && option.getAttribute('data-ps-option-key');
      var index = option ? Array.from(option.querySelectorAll('.ps-choice')).indexOf(c) : -1;
      /* The app may replace choices or stop bubbling while updating the selection. */
      previewTimer = setTimeout(function () {
        var freshOption = Array.from(root.querySelectorAll('.ps-option')).find(function (o) { return o.getAttribute('data-ps-option-key') === key; });
        var fresh = freshOption && freshOption.querySelectorAll('.ps-choice')[index];
        if (!fresh || !fresh.querySelector('.ps-choice__popup img')) return;
        place(fresh);
        fresh.classList.add('fn-ps-peek');
        previewChoice = fresh;
        previewTimer = setTimeout(hidePreview, 3000);
      }, 0);
    }, true);
    document.addEventListener('click', function (e) {
      if (previewChoice && !previewChoice.contains(e.target)) hidePreview();
    }, true);
    window.addEventListener('resize', hidePreview);

  }

  window.addEventListener('beforeunload', function (event) {
    if (!document.querySelector('[data-patchstitch-root] .ps-upload__dropzone.is-busy')) return;
    event.preventDefault();
    event.returnValue = '';
  });

  /* 手机端定制面板在屏幕上时给 <html> 加 fn-in-config，CSS 据此隐藏第三方悬浮图标（见 fn-ps-skin.css） */
  var configIO = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.__fnVisible = e.isIntersecting; });
    var any = Array.prototype.some.call(document.querySelectorAll('.fn-config'), function (c) { return c.__fnVisible; });
    document.documentElement.classList.toggle('fn-in-config', any);
  });

  /* App 的尺码表（Loomina「Size」类型选项）：部分选项的文字没翻译，这里改成法语。
     默认单位不用管：App 自 patchstitch-26 起按顾客国家默认 cm（美英加等除外）。
     - 「Size Guide」→「Guide des tailles」，inch → pouces / po
     - 弹窗里高亮顾客当前选的尺码（打开弹窗时记下所在选项的已选值）
     弹窗挂在 <body> 上，不在定制面板里，所以由下面的全局 scan 套用；只在文字不同时才改，避免观察器循环 */
  var guideSize = '';
  function setText(node, txt) { if (node && node.textContent !== txt) node.textContent = txt; }
  function inchText(node, short) {
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT), t, v;
    while ((t = walker.nextNode())) { v = t.nodeValue.replace(/\binch\b/g, short ? 'po' : 'pouces'); if (v !== t.nodeValue) t.nodeValue = v; }
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.ps-size-guide-link');
    if (!link) return;
    var opt = link.closest('.ps-option'), picked = opt && opt.querySelector('input:checked, .ps-choice[data-selected="true"]');
    guideSize = picked ? clean((picked.closest('label') || picked).textContent) : '';
  }, true);
  function sizeChart() {
    document.querySelectorAll('.ps-size-guide-link').forEach(function (a) { setText(a, 'Guide des tailles'); });
    document.querySelectorAll('.ps-size-detail').forEach(function (d) { inchText(d, true); });
    document.querySelectorAll('.ps-size-chart').forEach(function (box) {
      setText(box.querySelector('.ps-size-chart__title'), 'Guide des tailles');
      if (box.getAttribute('aria-label') !== 'Guide des tailles') box.setAttribute('aria-label', 'Guide des tailles');
      box.querySelectorAll('.ps-size-chart__unit').forEach(function (b) { inchText(b, false); });
      box.querySelectorAll('thead th').forEach(function (th) { inchText(th, true); });
      box.querySelectorAll('tbody tr').forEach(function (tr) {
        var on = !!guideSize && clean(tr.firstElementChild.textContent) === guideSize;
        if (tr.classList.contains('fn-ps-size-on') !== on) tr.classList.toggle('fn-ps-size-on', on);
      });
    });
  }

  function scan() {
    document.querySelectorAll('[data-patchstitch-root]').forEach(boot);
    translateCrop();
    sizeChart();
    if (configIO) document.querySelectorAll('.fn-config').forEach(function (c) { if (!c.__fnIO) { c.__fnIO = true; configIO.observe(c); } });
  }
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
